import React from 'react';
import { productCategories, stats } from '../mock';

const GlobalScale = () => {
  return (
    <section className="relative py-16 lg:py-24 bg-[#061c3f] text-white overflow-hidden">
      <div className="absolute -top-40 -left-40 w-96 h-96 rounded-full bg-[#00bceb]/10 blur-3xl" />
      <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full bg-[#00bceb]/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold max-w-3xl leading-tight">
          Global scale. Unified technology. Powered by AI.
        </h2>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {productCategories.map((p) => (
            <a
              key={p.label}
              href="#"
              className="group bg-white/5 hover:bg-white/10 border border-white/10 rounded p-6 flex flex-col items-center text-center transition-colors"
            >
              <img src={p.icon} alt="" className="w-16 h-16 mb-4 group-hover:scale-110 transition-transform" />
              <span className="font-semibold text-lg text-white">{p.label}</span>
            </a>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 border-t border-white/10 pt-12">
          {stats.map((s) => (
            <div key={s.label}>
              <div className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#00bceb] mb-2">{s.value}</div>
              <div className="text-sm md:text-base text-gray-300 max-w-xs">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlobalScale;
